module.exports = __webpack_public_path__ + "img/e265a73.png";